export const notFoundEnLocale = {
  'not-found.title': 'Page not found',
  'not-found.description':
    "We couldn't find what you were looking for. Please check and try again.",
  'not-found.go-back': 'Go back',
  'not-found.take-me-home': 'Take me home',
} as const;

export const notFoundEsLocale = {
  'not-found.title': 'Página no encontrada',
  'not-found.description':
    'No pudimos encontrar lo que estabas buscando. Por favor, verifica e intenta de nuevo.',
  'not-found.go-back': 'Volver',
  'not-found.take-me-home': 'Ir al inicio',
} as const;
